var React = require('react');
import MasterInput from './master'
class PhoneInput extends React.Component {

    render() {
        return (
            <MasterInput
                type='phone'
                actions={this.props.actions}
                store={this.props.store}
                fields={this.props.fields}
                name={this.props.name}
            />
        );
    }
}

export default PhoneInput
